import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { fromEvent, merge, Subscription, asyncScheduler } from 'rxjs'; // Import asyncScheduler from 'rxjs'
import { throttleTime } from 'rxjs/operators'; // Keep throttleTime in 'rxjs/operators'
import { LoopBackAuth } from '../sdk/services/core/auth.service';

@Injectable({ providedIn: 'root' })
export class IdleActivityService implements OnDestroy {

  private sub: Subscription;
  // Refresh at most once every 5 minutes (300,000 ms)
  private readonly REFRESH_THROTTLE_MS = 5 * 60 * 1000;

  constructor(
    private auth: LoopBackAuth,
    private zone: NgZone,
    private http: HttpClient
  ) {}

  start() {
    this.zone.runOutsideAngular(() => {

      const activity$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'mousedown'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'scroll'),
        fromEvent(document, 'touchstart')
      ).pipe(
        // Leading true fires on first movement, trailing true ensures final activity is captured
        throttleTime(this.REFRESH_THROTTLE_MS, asyncScheduler, { leading: true, trailing: true })
      );

      this.sub = activity$.subscribe(() => {
        // Force the HTTP response and state update back into Angular's Zone
        this.zone.run(() => {
          this.touchToken();
        });
      });
    });
  }

  private touchToken() {
    const tokenObj = this.auth.getToken();
    // SDKToken stores the actual token string in .id
    const rawToken = tokenObj?.id;

    if (!rawToken || typeof rawToken !== 'string') {
      return;
    }

    const url = `/api/1.0/FSUsers/refresh-token?access_token=${encodeURIComponent(rawToken)}`;
    const headers = { Authorization: `Bearer ${rawToken}` };

    this.http.post<any>(url, {}, { headers }).subscribe({
      next: (res) => {
        const currentToken = this.auth.getToken();
        if (currentToken) {
          currentToken.id = res.id;
          currentToken.ttl = res.ttl;
          currentToken.created = new Date();

          this.auth.setToken(currentToken);
          this.auth.save();
          console.log('--- SESSION EXTENDED VIA ACTIVITY ---', currentToken.created);
        }
      },
      error: (err) => {
        console.error('Failed to extend session token:', err);
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

}

